module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"invoice":"Счет","field_due_amt":"К оплате","ad_hoc_name":"Имя Товара","ad_hoc_amount":"Цена Товара","ad_hoc_total":"Всего","pay_invoice":"Оплатить Счет"},"en":{"invoice":"Invoice","field_due_amt":"Amount due","ad_hoc_name":"Item Name","ad_hoc_amount":"Item Price","ad_hoc_total":"Item Total","pay_invoice":"Pay Invoice Now"}}')
  delete Component.options._Ctor
}
